import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StrategyInstrumentDropdownInputComponent } from './strategy-instrument-dropdown-input.component';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    StrategyInstrumentDropdownInputComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    AngularSvgIconModule,
    FormsModule,

  ],
  providers: [
    TranslatePipe,
  ],
  exports: [
    StrategyInstrumentDropdownInputComponent,
  ]
})
export class StrategyInstrumentDropdownInputModule { }
